<mat-toolbar class="ori-elevation-z4 header">
  <mat-icon svgIcon="file-tree"></mat-icon>
  <h3>{{ "pym.title" | translate }}</h3>
  <mat-icon
    class="icon icon-close"
    [ngClass]="{ hidden: isLoading }"
    (click)="close()"
    color="primary"
    svgIcon="close"></mat-icon>
</mat-toolbar>

<o-loading [isLoading]="isLoading" [textToDisplay]="'pym.spinner.message' | translate"></o-loading>

@if (!isLoading) {
  <div>
    <div class="content">
      <div class="section">
        <div class="label">{{ "pym.depth" | translate }}</div>
        <mat-slider class="slider" [max]="5" [min]="1" [step]="1" [discrete]="true" [showTickMarks]="true">
          <input matSliderThumb [(ngModel)]="depth" />
        </mat-slider>
      </div>
      <div class="section">
        <div class="label">
          {{ "pym.info.label" | translate }}
          <div class="sub-label" [ngClass]="{ errorColor: isInvalid() }">{{ "pym.info.sublabel" | translate }}</div>
        </div>
        <div class="input">
          <mat-checkbox [(ngModel)]="main">{{ "pym.info.main" | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="conditional">{{ "pym.info.conditional" | translate }}</mat-checkbox>
          <mat-checkbox [(ngModel)]="general">{{ "pym.info.general" | translate }}</mat-checkbox>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <div class="action-buttons">
        <button
          (click)="submit()"
          class="btn-state"
          mat-button-raised
          color="primary"
          mat-raised-button=""
          [disabled]="isInvalid()">
          <span class="mat-button-wrapper">{{ "pym.action" | translate }}</span>
          <div class="mat-button-ripple mat-ripple" mat-ripple=""></div>
          <div class="mat-button-focus-overlay"></div>
        </button>
      </div>
    </div>
  </div>
}
